module.exports = __webpack_public_path__ + "img/witcloud-logo.ee860167.png";